var TOKEN_LENGTH = 24;

function SessionToken(external) {
    this.put = function(destination) {
        destination.writeBytes(external);
    };

    this.toString = function() {
        return external.toString('ascii');
    };
}

SessionToken.fromExternalString = function(external) {
    return new SessionToken(new Buffer(external, 'ascii'));
};

SessionToken.TOKEN_LENGTH = TOKEN_LENGTH;

module.exports = SessionToken;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/session/session-token.js
// module id = 1066
// module chunks = 1